import { environment } from "src/environments/environment";

export class ConstantsFordProtect {

	public static SYSTEM_COUNTRY = "SYSTEM_COUNTRY";
	public static USER_COUNTRY = "USER_COUNTRY";
	public static TERM_UNIT = "MO";
	public static DISTANCE_UNIT = "KM";
	public static MAINTENANCE = "MANUTENCAO";
	public static EXTENSION = "EXTENSAO";
	public static REPAIRS = "REPAROS";
	public static SIGNALS = "SINISTROS";
	public static WINCHES = "GUINCHO";
	public static WEAR = "DESGASTE";
	public static TMAC = "TMAC";

	// paises
	public static BRA = "BRA";
	public static ARG = "ARG";
	public static CHL = "CHL";
	public static COL = "COL";
	public static VEN = "VEN";

	public static ES_AR = 'es-AR';
	public static PT_BR = 'pt-BR';
	public static ES_CL = 'es-CL';
	public static ES_CO = 'es-CO';
	public static ES_VE = 'es-VE';

	public static EMPTY_PHONE_ARGENTINA = '000000000000';
	public static DOUBLE_ZERO = '00';

	public static PRICE_CUSTOMER = "PRICE_CUSTOMER";
	public static SELLER_PRICE = "SELLER_PRICE";
	public static COST_FORD = "COST_FORD";
	public static COST_WARRANTY = "COST_WARRANTY";
	public static COST_SERVICE = "COST_SERVICE";
	public static REAL = "R$";
	public static PESO = "$";
	public static DEALER = 5;
	public static TELEMARKETING = 30;
	public static COVERAGE_ACTIVE = 1;
	public static COVERAGE_INACTIVE = 0;

	public static OPEN_API_ENDPOINT = environment.myApiConfig.uri + "/api/contracts/signature/, " + environment.myApiConfig.uri + "/api/contracts/contract-signature/save, " + environment.myApiConfig.uri + "/api/sellers/seller-id/, " + environment.myApiConfig.uri + "/api/dealers/signature/";
	// adicionar as URLS que são abertas no front
	public static OPEN_URL_FRONT = "/contract-signature?uuid=";

	// contracts
	public static CONTRACT_ATIVO_CODE = 5;
	public static CONTRACT_ATIVO_NAME = 'ATIVO';
	public static CONTRACT_BLOQUEADO_CODE = 10;
	public static CONTRACT_CANCELADO_CODE = 15;
	public static CONTRACT_FINALIZADO_CODE = 20;
	public static CONTRACT_CRIADO_CODE = 25;
	public static CONTRACT_PENDENTE_PAGAMENTO_CODE = 30;
	public static CONTRACT_PENDENTE_CANCELAMIENTO_CODE = 55;
	public static CONTRACT_PENDENTE_ACTIVACAO_CODE = 60;
	public static CONTRACT_PENDENTE_ALTERACAO_CODE = 65;
	public static CONTRACT_COM_ERRO_CODE = 95;

	// dates
	public static DATE_START = "2024-01-01";
	public static DATE_END = "2099-01-01";

	// Invoices
	public static INVOICE = "Nota Fiscal";

	// Months
	public static JANUARY = "01";
	public static FEBRUARY = "02";
	public static MARCH = "03";
	public static APRIL = "04";
	public static MAY = "05";
	public static JUNE = "06";
	public static JULY = "07";
	public static AUGUST = "08";
	public static SEPTEMBER = "09";
	public static OCTOBER = "10";
	public static NOVEMBER = "11";
	public static DECEMBER = "12";

	// product codes
	public static BAS1 = "BAS1";
	public static PLS1 = "PLS1";
	public static PREB = "PREB";
	public static PMPR = "PMPR";
	public static FLEEC = "FLEEC";
	public static FORD_GO = "FDGO";

	// Items for Account Code OWS 
	public static ESB = 'ESB';
	public static ESBG = 'ESBG';
	public static ESMP = 'ESMP';
	public static EXTE = 'EXTE';
	public static FLEE = 'FLEE';
	public static FLSN = 'FLSN';
	public static FLMT = 'FLMT';

	// Item for All
	public static NULO = 'NULO';
	public static OTHERS = 'OUTROS';

	// Items for Action Code OWS 
	public static A = 'A';

	// Items for Sub Code
	public static AST = 'AST';
	public static ESP = 'ESP';
	public static QCM = 'QCM';

	// Items for Insurange Code
	public static MNTC = 'MNTC';
	public static REP = 'REP';
	public static WTY = 'WTY';

	// CANCELLATION REASON
	public static WITHDRAWAL = "Desistência";
	public static CHARGEBACK = "Estorno";
	public static THEFT = "Roubo";
	public static TOTAL_LOSS = "Perda Total";
	public static OTHER = "Outros";

	// TYPE OF PERSON
	public static PHYSICAL_PERSON = "PF";
	public static LEGAL_PERSON = "PJ";

	// TYPE PAYMENT
	public static CASH_PAYMENT = "À VISTA";
	public static PAYMENT_INSTALLMENT = "PARCELADO";

	// use
	public static EMISSION_USER = "EMISSAO";

	// PAndAC default values
	public static PANDAC_BRA_DEFAULT = "00100";
	public static PANDAC_ARG_DEFAULT = "00502";


}

